import styled from 'styled-components';

export const ChartContainer = styled.div`
    width: 100%;
    height: 420px;
`;
